<template>
	<div class="recurrence-list-item">
		<div>
			<h1 class="title">{{ name }}</h1>
			<div class="description">
				<FontAwesomeIcon :icon="[ `far`, `clock` ]" />
				<div>{{ description }}</div>
			</div>
			<div v-if="templateName" class="template-name">
				<FontAwesomeIcon :icon="[ `fas`, `square-list` ]" />
				<div>{{ templateName }}</div>
			</div>
		</div>
		<div v-tooltip="disabled ? translate(`editDisabled`) : ''">
			<TeamingButton2
				size="SMALL"
				type="TERTIARY"
				@click="onClick"
				:disabled="disabled"
			>
				{{ translate( `editButton` ) }}
			</TeamingButton2>
		</div>
	</div>
</template>

<script>
import { computed } from "vue";
import {
	TranslateMixin,
	TeamingButton2
} from "@teaming/common-ui";

export default {
	name: "RecurrenceListItem",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	emits: [ "edit", ],
	components: { TeamingButton2, },
	props: {
		name: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
		templateName: {
			type: String,
			required: false,
		},
		managedBy: {
			type: String,
			required: false,
			default: () => 'ui',
		},
	},
	setup(props, { emit }) {
		const disabled = computed(() => props.managedBy === 'ics');
		const onClick = () => {
			if (!disabled.value) {
				emit('edit');
			}
		};

		return {
			disabled,
			onClick
		};
	},
};
</script>

<style lang="scss" scoped>
$backgroundColor: $color1-050;
$titleColor: $color1-700;
$descriptionColor: $color1-500;

.recurrence-list-item {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	width: 100%;
	background-color: $backgroundColor;
	border-radius: 0.5rem;
	padding: 1rem;
}

.recurrence-list-item .title {
	@include font-and-line-for(1);
	color: $titleColor;
}

.recurrence-list-item .description,
.recurrence-list-item .template-name {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;

	@include font-and-line-for(0);
	color: $descriptionColor;
}
</style>
